module.exports = __webpack_public_path__ + "static/media/pdf.feb08f2f.svg";